<!--图片上传-->
<template>
  <div>
      <el-upload style="display:flex" :action="api.uploadFileUrl" :headers="headers" accept=".mp4,.m4a,.aac"
                 :on-preview="handlePictureCardPreview2" :on-success="uploadPictureSuccess"
                 :show-file-list="true" :on-remove="handleRemoveVideo" :on-change="uploadPictureChange"
                 list-type="picture-card" class="videoUpload">
  <!--      <div v-for="video in videoList" :key="video.url">-->
  <!--        <video width="100%" controls="controls" :src="video.url" class="avatar"></video>-->
  <!--      </div>-->
        <div v-for="(video, index) in videoList" :key="index" class="video-container">
          <video width="100%" controls="controls" :src="video.url" class="avatar"></video>
        </div>
        <i class="el-icon-plus"></i>
      </el-upload>

    <!--
    <el-image-viewer
      v-if="dialogVisible"
      :on-close="closeImgViewer"
      :url-list="dialogImageUrlList"/> -->
  </div>
</template>

<script>
import api from "@/api/projectApi";
import store from "@/store";

export default {
  name: 'videoUpload',
  props: {
    photoUrl: {
      type: [Array],
      require: true
    },
    index: {
      type: [Number],
      require: true
    }
  },

  computed: {
    api() {
      return api
    },
    headers: function () {
      const tenantId = store.getters.userInfo.tenantId
      return {
        'Authorization': "Bearer " + store.getters.access_token,
        'TENANT-ID': tenantId
      };
    }
  },
  mounted(){
    console.log(this.photoUrl,"photoUrl传来的视频");
  },
  components: {
    'el-image-viewer': () => import('element-ui/packages/image/src/image-viewer')
  },

  data() {
    return {
      videoUrl2:'',
      videoList:[],

      dialogImageUrlList: [],
      dialogVisible: false,
      picList: [],

    }
  },

  watch: {
    photoUrl: {
      handler(url) {
        if (url) {
          let list = []
          if (url !== null && url !== '' && url !== undefined) {
            this.videoUrl2=url,
              console.log(url, "name55555");

          }


        } else {

        }
      },
      deep: true,
      immediate: false,
    },

    videoList: {
      handler(n) {
        if (n.length > 0) {
          console.log(this.videoList, n, "触发l此处");
          this.$emit('update:photoUrl', this.videoList)
        }
      },
      deep: true,
      immediate: false,
    },

  },


  methods: {
    handleRemoveVideo(file, fileList) {
      this.hideUpload = fileList.length >= this.limitCount;

      console.log(file, fileList);
      // 调删除图片接口
      // deleteFileByName({ fileName: this.form.url }).then(res => {
      //   if (res.code == 200) {
      //     // this.form.url = ''
      //     // this.form.time = ''
      //     this.$message({
      //       message: res.msg,
      //       type: 'success'
      //     });
      //     this.isShow = false
      //   }
      // })

    },
    // 视频
    handlePictureCardPreview2(file) {
      console.log(file, file.url, "99999")
      // this.videoUrl = file.url;

    },
    uploadPictureSuccess(res, file) {
      if (file.status == "success") {
        this.$message({
          message: '录音/视频上传成功',
          type: 'success'
        });
        console.log(res, file, '上传成功后的res视频');
        this.videoList.push({ name: file.name, url: res.data.url });
        console.log(this.videoList, "上传的视频1111");
      }
      this.isShow = true;
      this.$emit('update:photoUrl', this.videoList); // 触发更新 photoUrl 的事件
    },
    uploadPictureChange(file, fileList) {
      console.log(file, fileList)
      let _this = this
      // this.hideUpload = fileList.length >= this.limitCount;
      var audioElement = new Audio(file.url), duration;
      audioElement.addEventListener("loadedmetadata", function () {
        // _this.form.time = audioElement.duration;
        // console.log('时长：' + _this.form.time + 's')
      })
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.table-detail .el-upload--picture-card {
  // margin-top: 10px;
  // width: 80px;
  height: 40px;
  line-height: 50px !important;
}

::v-deep .el-upload-list .el-upload-list__item {
  display: inline-block;
  display: none;
  width: 165px;
  height: 40px;
  margin-right: 14px;
  border-radius: 2px;
  padding: 0 !important;
  border-color: #e8e8e8;
  margin-top: 0;
  margin-bottom: 10px;
  background-color: #e9e9e9;
}

::v-deep .el-upload-list .el-upload-list__item .el-upload-list__item-thumbnail {
  // width: 80px;
  height: 40px;
  padding: 0 !important;
  position: inherit;
  cursor: pointer;
}

::v-deep.el-upload-list__item.is-success .el-upload-list__item-status-label {
  display: none !important;
}

::v-deep .el-upload {
  display: block;
  height: 40px;
  width: 40px;
  border-radius: 5px;
  line-height: 40px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  font-size: 21px;
}

::v-deep .is-success {
  position: relative;
}

::v-deep .videoUpload {
  position: relative;
}




::v-deep .avatar {
  // position: absolute;
  width: 130px;
  height: 70px;
  margin-left: 100px;
  margin-bottom: 5px;
  // top: -20px;
  // left: 70px;
}

// >>>.el-upload-list__item.is-ready,
// .el-upload-list__item.is-uploading {
//   display: none !important;
// }

::v-deep .el-upload-list__item {
  transition: none !important;
}
.el-upload--picture-card i {
    position: absolute;
    top: 10px;
    left: 10px;
    font-size: 21px;
    color: #000000;
}
</style>
